import { Inline, Stack } from "PFComponents/containers";
import { LoadingDots } from "PFComponents/loading_dots";
import { Typography } from "PFComponents/typography";
import { useActivityVacancies } from "PFCore/hooks/queries/activity";
import { Activity } from "PFTypes";
import { Trans, useTranslation } from "react-i18next";

type ActivityDetailsVacanciesProps = {
  activity: Activity;
};

export const ActivityDetailsVacancies = ({ activity }: ActivityDetailsVacanciesProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.details.vacancies" });

  const { isFetching, data: vacancies } = useActivityVacancies(
    {
      activityId: activity.id,
      perPage: 0
    },
    {
      enabled: !activity.id
    }
  );

  return (
    <Stack gap="spacingMd">
      <Typography variant="h5">{t("title")}</Typography>
      {isFetching ? (
        <LoadingDots />
      ) : (
        <div>
          <Inline gap="spacingSm">
            <Typography withMargin variant="bodyRegular" tag="span">
              <Trans
                t={t}
                i18nKey={"open"}
                values={{ count: vacancies?.meta.totalOpened }}
                components={[<Typography withMargin key={0} variant="bodyBold" tag="span" />]}
              />
            </Typography>
          </Inline>
          <Inline gap="spacingSm">
            <Typography withMargin variant="bodyRegular" tag="span">
              <Trans
                t={t}
                i18nKey={"total"}
                values={{ count: vacancies?.meta.total }}
                components={[<Typography withMargin key={0} variant="bodyBold" tag="span" />]}
              />
            </Typography>
          </Inline>
        </div>
      )}
    </Stack>
  );
};
